import React from 'react';
import CapabilitiesPageResults from './CapabilitiesPageResults';

function PageResults(props) {
  return <CapabilitiesPageResults {...props} />;
}

export default PageResults;
